var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockBottomLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 63,
    viewBox: "0 0 54 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76059 26.5056V35.2451H-0.00390625V26.5056H8.76059Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76449 44.2605V53H0V44.2605H8.76449Z",
    fill: "#FBE683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99887 19.9998V28.7393H0.234375V19.9998H8.99887Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5848 26.5076V35.2471H43.8203V26.5076H52.5848Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76059 9.02712V17.7666H-0.00390625V9.02712H8.76059Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5262 0.287866V9.02734H8.76172V0.287866H17.5262Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3465 17.7664V26.5059H52.582V17.7664H61.3465Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76449 -0.000220299V8.73926H0V-0.000220299H8.76449Z",
    fill: "#DDA4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 17.7664V26.5059H17.5234V17.7664H26.2879Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 48.8972V57.6367H17.5234V48.8972H26.2879Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8192 9.02712V17.7666H35.0547V9.02712H43.8192Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7645 -0.000220299V8.73926H26V-0.000220299H34.7645Z",
    fill: "#218595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7645 29.9998V38.7393H17V29.9998H25.7645Z",
    fill: "#F5D858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7645 8.99978V17.7393H17V8.99978H25.7645Z",
    fill: "#8DA9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 63,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockBottomLeft);
export default __webpack_public_path__ + "static/media/block-bottom-left.3ff4bbf5f3bb632b4c7ff270a937750a.svg";
export { ForwardRef as ReactComponent };